import { render, staticRenderFns } from "./addSchedule.vue?vue&type=template&id=1275e6cb&scoped=true&"
import script from "./addSchedule.vue?vue&type=script&lang=js&"
export * from "./addSchedule.vue?vue&type=script&lang=js&"
import style0 from "./addSchedule.vue?vue&type=style&index=0&id=1275e6cb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275e6cb",
  null
  
)

export default component.exports